import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["item", "intersect"];
import TargetLink from "@/components/TargetLink";
import CardArtwork from "@/components/Card/CardArtwork";
import { useSliderPosition } from "@/hooks";
import styles from "@/styles/Card.module.scss";
import { useRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AdvertCard(props) {
  var item = props.item,
      intersect = props.intersect,
      props_ = _objectWithoutProperties(props, _excluded);

  var cardRef = useRef();
  var classNames = useSliderPosition(props_, cardRef);
  return /*#__PURE__*/_jsx("div", {
    ref: cardRef,
    className: classNames,
    children: /*#__PURE__*/_jsx(TargetLink, {
      href: item.url,
      blank: item.targetBlank,
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(CardArtwork, {
          item: item,
          intersect: intersect
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.infoContainer,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.info,
            children: /*#__PURE__*/_jsx("div", {
              className: styles.title,
              children: /*#__PURE__*/_jsx("p", {
                children: item.name
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "".concat(styles.feature, " ").concat(styles.info),
            children: props_.focusIndex != null && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("div", {
                className: styles.title,
                children: /*#__PURE__*/_jsx("p", {
                  children: item.name
                })
              }), /*#__PURE__*/_jsx("div", {
                className: styles.description,
                children: /*#__PURE__*/_jsx("p", {
                  children: item.description
                })
              })]
            })
          })]
        })]
      })
    })
  });
}